module.exports = "https://assets.meiaentrada.org.br/static/media/cartilha-procon.f770a2eb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documents/cartilha-procon.pdf
// module id = 124
// module chunks = 0